// @flow
import * as React from 'react';
import { injectIntl, FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import safeUrl from '../util/safeUrl';
import { observer } from 'mobx-react'
import { toJS, toJSON } from 'mobx';

import DetectionsTable from '../components/DetectionsTable.js';

import navigationStructure from '../NavigationStructure.js';

import "../css/Summary.css";

import type { AppStateType, HeadlineType, DataType } from '../Types';

import helpers from '../util/helpers';

type Props = {
  appState: AppStateType,
  intl: Object,
  match: Object,
  history: Object,
};



class SummaryPage extends React.Component<Props> {

  constructor(props) {
    super(props)
  }


  componentWillMount() {
    /*
    // already loaded in App.js (and using a promise on authentication)
    if(this.props.appState.headlines.length === 0) {
      this.props.appState.loadHeadlines();
    }
    */
  }

  // headlines() : HeadlineType[] {
  //   if(this.waterpage()) {
  //     return this.props.appState.headlines
  //       .filter((d) => d.group === "Water CVOCs" || d.group === "Water Phthalates")
  //       .sort((a, b) => a.priority - b.priority)
  //   }
  //   else {
  //     return this.props.appState.headlines
  //       .filter((d) => d.group !== "Water CVOCs" && d.group !== "Water Phthalates")
  //       .sort((a, b) => a.priority - b.priority)
  //       .slice(0, 4);
  //   }
  // }

  headlineToHTML(headline) {
    // this takes the markdown link formatting of the headline [*](*)
    // and turns it into an html underline
    // assumes only one line per headline

    let htmlHeadline;
    if (headline.includes("](")) {
      let middleIndex = headline.indexOf("](")
      let startIndex = headline.lastIndexOf("[", middleIndex)
      let endIndex = headline.indexOf(")", middleIndex)

      if (startIndex != -1 && endIndex != -1) {
        let beforeText = headline.substring(0, startIndex);
        let linkName = headline.substring(startIndex+1, middleIndex);
        let remainingText = headline.substring(endIndex+1)
        htmlHeadline = (<span>{beforeText}<span className="underline">{linkName}</span>{remainingText}</span>)
      }

    }

    return htmlHeadline
  }

  getHighHeadlines() {
    let relevantHeadlines;
    relevantHeadlines = this.props.appState.headlines
      .sort((a, b) => a.priority - b.priority)

     // version 1: read the priority based on what's set by the researcher in priority_hml
    // let highHeadlines = [];
    // for (let i = 0; i < relevantHeadlines.length; i++) {
    //   let priority = relevantHeadlines[i].priority_hml
    //   if (priority == "1-high") {
    //     highHeadlines.push(relevantHeadlines[i])
    //   }
    // }

    //  version 2: read the priority based on a threshold for priorities
    let highHeadlines = [];
    let highPriorityThreshold = 8
    for (let i = 0; i < relevantHeadlines.length; i++) {
      let priority = relevantHeadlines[i].priority
      if (priority <= highPriorityThreshold) {
        highHeadlines.push(relevantHeadlines[i])
      }
    }

    return highHeadlines
  }

  getLowChemicals() {
    let relevantHeadlines;
    relevantHeadlines = this.props.appState.headlines
      .sort((a, b) => a.priority - b.priority)

    // // Version 1: read the priority based on what's set by the researcher in priority_hml
    // let lowGroups = [];
    // for (let i = 0; i < relevantHeadlines.length; i++) {
    //   let priority = relevantHeadlines[i].priority_hml
    //   if (priority != "1-high") {
    //     lowGroups.push(relevantHeadlines[i].group)
    //   }
    // }

    //  version 2: read the priority based on a threshold for priorities
    let lowGroups = [];
    let highPriorityThreshold = 8
    for (let i = 0; i < relevantHeadlines.length; i++) {
      let priority = relevantHeadlines[i].priority
      if (priority > highPriorityThreshold) {
        lowGroups.push(relevantHeadlines[i].group)
      }
    }

    // get list of all groups
    let relevantGroups = [];
    for (let x in this.props.appState.groups) {relevantGroups.push(x)}


    // find groups without headlines
    let noHeadlines = [];
    for (let g = 0; g < relevantGroups.length; g++) {
      let headlineFound = false
      for (let i = 0; i < relevantHeadlines.length; i++) {
        let group = relevantHeadlines[i].group
        if (group == relevantGroups[g]) {
          headlineFound = true;
          break
        }

      }
      if (!headlineFound) {
        noHeadlines.push(relevantGroups[g])
      }
    }


    // if there are groups without headlines, see if there is a result for this participant

    if (noHeadlines.length > 0) {
      for (const dataPoint of this.props.appState.data) {
        if (noHeadlines.length == 0) {
          break;
        }
        if (noHeadlines.includes(dataPoint.group)) {
          // there is a measurement, just no headline;
          lowGroups.push(dataPoint.group)
          let index = noHeadlines.indexOf(dataPoint.group)
          noHeadlines.splice(index, 1)
        }
      }

    }

    return  [lowGroups, noHeadlines]
  }


  mydetections_waterFilterFunction(d: DataType | HeadlineType): boolean {
    // "this": value of the optional argument to a JS filter function, send true or false
    let ispagewater = this;
    let isdatawater = (d.group === "Water CVOCs" || d.group === "Water Phthalates")
    if (ispagewater === true)
      return isdatawater;
    else
      return !isdatawater;
  }

  mydetections_Compare(a: DataType, b: DataType): number {
    let x = a.chemical_full + a.visit;
    let y = b.chemical_full + b.visit;
    return ((x < y) ? -1 : ((x > y) ? 1 : 0));
  }

  mydetections_UNFILTERED():  DataType[] {
    //let wantwaterYN = this.waterpage();
    return this.props.appState.data
      .filter((d) => d.mine === true);
    //  .filter(this.mydetections_waterFilterFunction, wantwaterYN)
    //  .sort(this.mydetections_Compare)
  }

  mydetections():  DataType[] {
    let wantwaterYN = this.waterpage();
    return this.props.appState.data
      .filter((d) => d.mine === true)
      .filter(this.mydetections_waterFilterFunction, wantwaterYN)
      .sort(this.mydetections_Compare)
  }

  waterpage() : boolean {
    return this.props.match.path === "/water_summary";
  }

  MOVEDconvertGroupName(name) : string {
    return name === "Sunscreen Chemicals" ? "sunscreen" : name.toLowerCase().replace(' ', '_');
  }

  goto(e,url) {
    e.preventDefault();
    helpers.eventLog("nav:summarypage link clicked -  - " + url);
    this.props.history.push(url);
    window.scrollTo(0, 0);
  }

  onClick(group, headline_priority) {
    helpers.eventLog(`nav:summarypage headline_clicked - ${group}_${headline_priority}`);
  }

  render() {
    let colorIndex = 0;
    let self = this;

    let highHeadlines = this.getHighHeadlines()
    let remainingHighHeadlines;
    if (highHeadlines.length > 2) {
      remainingHighHeadlines = highHeadlines.slice(2, highHeadlines.length)
      highHeadlines = highHeadlines.slice(0,2)
    }

    let headlinesDisplay = highHeadlines.map(function(headline) {
      let iconUrl = safeUrl(`/images/${self.props.intl.messages['chemicals.' + helpers.convertGroupName(headline.group) + '.icon']}`)
      return(
        <div key={headline.summary} onClick={() => self.onClick(headline.group, "highHeadlineBox")}>
          <Link className="high-headline-box" to={`/chemicals/${helpers.convertGroupName(headline.group)}`}>
            <div className='group-icon'>
              <span className='group-icon' style={{
                  mask: `url(${iconUrl})`,
                  WebkitMask: `url(${iconUrl})`,
                  display: "inline-block",
                  background: "black",
                  WebkitMaskSize: "cover",
                  maskSize: "cover",
                  width: 40,
                  height: 40,
                }}/>
            </div>
            <div className='headline-summary-text'>
              <strong>{self.headlineToHTML(headline.summary)}</strong>
            </div>
            <p>
              <em><FormattedMessage id='learn_more_and_improve' defaultMessage='Lo que puedes hacer' /></em><br/>
            </p>
          </Link>
        </div>
      )
    })

    let remainingHighHeadlinesDisplay = null;
    if (remainingHighHeadlines) {
      let remainingHighHeadlinesList = remainingHighHeadlines.map(function(headline) {
        let iconUrl = safeUrl(`/images/${self.props.intl.messages['chemicals.' + helpers.convertGroupName(headline.group) + '.icon']}`)
        let hexColor = helpers.getIconColor(helpers.convertGroupName(headline.group), self.props.intl)

        return (
          <div key={headline.summary} onClick={() => self.onClick(headline.group, "highHeadlineList")}>
            <Link key={headline.summary} className="high-chemical-name" to={`/chemicals/${helpers.convertGroupName(headline.group)}`}>
              <span className="group-icon-wrapper">
                <span className='group-icon' style={{
                    mask: `url(${iconUrl})`,
                    WebkitMask: `url(${iconUrl})`,
                    display: "inline-block",
                    background: hexColor,
                    WebkitMaskSize: "cover",
                    maskSize: "cover",
                    width: 40,
                    height: 40,
                  }}/>
              </span>
              <p className='low-chemical-name'><FormattedMessage id={'chemicals.' + helpers.convertGroupName(headline.group) + '.title'} /></p>
            </Link>
          </div>
        )
      })

      remainingHighHeadlinesDisplay = (
        <div className="high-chemical-summary">
          <p><FormattedHTMLMessage id='also_higher_levels_for' defaultMessage='TODO' /></p>
          {remainingHighHeadlinesList}
        </div>
      )
    }

    let lowChemicals;
    let noResults;
    [lowChemicals, noResults] = this.getLowChemicals();

    let lowChemicalsDisplay = null;
    if (lowChemicals.length > 0) {
      let lowChemicalsList = lowChemicals.map(function (group) {
        let iconUrl = safeUrl(`/images/${self.props.intl.messages['chemicals.' + helpers.convertGroupName(group) + '.icon']}`)
        let hexColor = helpers.getIconColor(helpers.convertGroupName(group), self.props.intl)

        return (
          <div key={group} onClick={() => self.onClick(group, "lowHeadline")}>
            <Link key={group} className="low-chemical-name" to={`/chemicals/${helpers.convertGroupName(group)}`}>
              <span className="group-icon-wrapper">
                <span className='group-icon' style={{
                    mask: `url(${iconUrl})`,
                    WebkitMask: `url(${iconUrl})`,
                    display: "inline-block",
                    background: hexColor,
                    WebkitMaskSize: "cover",
                    maskSize: "cover",
                    width: 40,
                    height: 40,
                  }}/>
              </span>
              <p className='low-chemical-name'><FormattedMessage id={'chemicals.' + helpers.convertGroupName(group) + '.title'} /></p>
            </Link>
          </div>
        )
      })

      lowChemicalsDisplay = (
        <div className="low-chemical-summary">
          <p><FormattedHTMLMessage id='same_or_lower_levels' defaultMessage='You had the same or lower levels' /></p>
          {lowChemicalsList}
        </div>
      )
    }

    let noResultsChemicalsDisplay = null;
    if (noResults.length > 0) {
      let noResultsList = noResults.map(function(group) {
        let iconUrl = safeUrl(`/images/${self.props.intl.messages['chemicals.' + helpers.convertGroupName(group) + '.icon']}`)
        let hexColor = helpers.getIconColor(helpers.convertGroupName(group), self.props.intl)

        return (
          <div key={group} onClick={() => self.onClick(group, "noResultHeadline")}>
            <Link key={group} className="low-chemical-name" to={`/chemicals/${helpers.convertGroupName(group)}`}>
              <span className="group-icon-wrapper">
                <span className='group-icon' style={{
                    mask: `url(${iconUrl})`,
                    WebkitMask: `url(${iconUrl})`,
                    display: "inline-block",
                    background: hexColor,
                    WebkitMaskSize: "cover",
                    maskSize: "cover",
                    width: 40,
                    height: 40,
                  }}/>
              </span>
              <p className='low-chemical-name'><FormattedMessage id={'chemicals.' + helpers.convertGroupName(group) + '.title'} /></p>
            </Link>
          </div>
        )
      })

      noResultsChemicalsDisplay = (
        <div className="low-chemical-summary">
          <p><FormattedMessage id='no_results_for' defaultMessage='TODO' /></p>
          {noResultsList}
        </div>
      )
    }


    //let tableDisplay = this.mydetectionsDisplayDoit(this.mydetections(), this.waterpage());

    let tableDisplay =  null; // move to AppendixPage -- print only

    /*
    let tableDisplay = <DetectionsTable
            thedetections={this.mydetections_UNFILTERED()}
            iswatertable={this.waterpage()}
            thispage={this}
              />
    */

    const header = this.waterpage() ?
      <FormattedMessage id='app.pages.water_summary.title' defaultMessage='Water Summary' /> :
      <FormattedMessage id='app.pages.summary.title' defaultMessage='Summary' />;

    return (
      <div className='page summary'>
        <h1>
          {header}
        </h1>
        <p><FormattedMessage id='app.pages.summary.desc' defaultMessage='Click each chemical group to see your complete results. When you’re done, continue to the rest of the report.' /></p>

        <div className='summary-table'>
          {headlinesDisplay}
          {remainingHighHeadlinesDisplay}
          {lowChemicalsDisplay}
          {noResultsChemicalsDisplay}
        </div>

        {tableDisplay}

      </div>

    );

  } //END render

} // END class SummaryPage





export default injectIntl(observer(SummaryPage));



// WEBPACK FOOTER //
// ./src/pages/SummaryPage.js